import { Link } from 'react-router';

/**
 * Quiet footer: Amassa, by Quotinc. Product chrome only, the same for every
 * tenant: the company line ("© 2026 asian trails · internal") was removed on
 * 2026-10-08 (brief R11, decision D2). The workspace is named on the About
 * page instead, which the line now opens.
 */
export function Footer() {
  return (
    <footer
      style={{
        borderTop: '1px solid var(--border)',
        padding: '13px 26px',
        fontFamily: 'var(--hm-mono)',
        fontSize: 10,
        letterSpacing: '0.16em',
        textTransform: 'uppercase',
        color: 'var(--text-dim)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 12,
        background: 'var(--bg)',
      }}
    >
      <Link
        to="/preferences/about"
        title="About Amassa"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 10,
          color: 'inherit',
          textDecoration: 'none',
        }}
      >
        <span
          aria-hidden
          style={{
            width: 22,
            height: 1,
            background: 'var(--grad-signal)',
            display: 'inline-block',
            opacity: 0.8,
          }}
        />
        amassa · by quotinc
      </Link>
    </footer>
  );
}
